// Login-handle format, mirrored from Portal-BE app/auth/username.js:
// 3–15 characters, lowercase ASCII letters and digits. Reserved words and
// profanity are checked server-side (GET /login/username/available and the
// write endpoints answer with a `code`); the FE only mirrors the shape so
// typing feedback is instant.

export const USERNAME_MIN = 3;
export const USERNAME_MAX = 15;

export type UsernameErrorCode = "too_short" | "too_long" | "invalid_chars" | "reserved" | "profanity" | "taken";

const KNOWN_CODES: ReadonlySet<string> = new Set(["too_short", "too_long", "invalid_chars", "reserved", "profanity", "taken"]);

/** Friendly normalisation while typing: lowercase, drop anything that is
 *  not a-z / 0-9, cap at 15. (The BE does NOT strip — it rejects — so what
 *  this returns is always something the BE will accept shape-wise.) */
export const normaliseUsername = (raw: string): string =>
    raw.toLowerCase().replace(/[^a-z0-9]/g, "").slice(0, USERNAME_MAX);

/** Shape check only. Null = fine. */
export const checkUsernameFormat = (username: string): UsernameErrorCode | null => {
    if (!/^[a-z0-9]*$/.test(username)) return "invalid_chars";
    if (username.length < USERNAME_MIN) return "too_short";
    if (username.length > USERNAME_MAX) return "too_long";
    return null;
};

/** i18n key for a server/client code; unknown codes fall back to a generic message. */
export const usernameErrorKey = (code: string | null | undefined): string =>
    code && KNOWN_CODES.has(code) ? `username_err_${code}` : "username_err_invalid";
